import React, {createBrowserRouter} from 'react-router-dom';
import {Navbar} from './components/Navbar/Navbar';
import {Page} from './components/Page';
import {Protected} from './components/Protected';
import {About} from './pages/About';
import {Account} from './pages/Account';
import {Community} from './pages/Community';
import {Home} from './pages/Home';

export const router = createBrowserRouter([
	{
		path: '/',
		element: (
			<>
				<Navbar />
				<Page>
					<Home />
				</Page>
			</>
		),
	},
	{
		path: '/account',
		element: (
			<>
				<Navbar />
				<Protected>
					<Page>
						<Account />
					</Page>
				</Protected>
			</>
		),
	},
	{
		path: '/community',
		element: (
			<>
				<Navbar />
				<Page>
					<Community />
				</Page>
			</>
		),
	},
	{
		path: '/about',
		element: (
			<>
				<Navbar />
				<Page>
					<About />
				</Page>
			</>
		),
	},
]);
